import { useEffect, useRef, useState } from 'react';
import { useI18n } from 'src/utils/lni18n';

import { useAtom } from 'jotai';
import courseService, { classesAtom } from '../CourseService';
import WaitRipple from 'src/components/WaitRipple';
import { debouncer } from 'src/utils/debouncer';
import { Link } from 'react-router-dom';


const CourseFindByStudentClass = () => {

    const { languageService: t } = useI18n();
    const [text, setText] = useState<string>("");

    const textDebouncerRef = useRef<debouncer>();

    useEffect(() => {
        textDebouncerRef.current = new debouncer(changeText, 300);
    }, []);

    const onChangeText = (text: string) => {
        setText(text);
        textDebouncerRef.current?.debounce(text);
    }


    const [classSearchData] = useAtom(classesAtom);

    const changeText = (text: string) => {
        setText(text);
        courseService.searchByClassName(text);
    }

    return <div className='mb-5 max-col-width'>

        {classSearchData.loading && <WaitRipple />}

        <div className='d-flex align-items-center mb-3'>

            <input type="text"
                placeholder={`${t.getText("name")}...`}
                className="form-control "
                value={text}
                onChange={(e) => onChangeText(e.target.value)}
            />

        </div>

        {classSearchData.classes.length > 0 &&
            <div className={`mt-3`} aria-live="polite">
                <table className="table table-striped">
                    <thead>
                        <tr>
                            <th className='border-0'>{t.getText('studentgroup')}</th>
                            <th className='border-0'>{t.getText('course')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {classSearchData.classes.map(p =>
                            <tr key={`${p.Id}-${p.CourseId}`}>
                                <td>
                                    {p.Name}
                                </td>
                                <td>
                                    <Link to={`/course/${p.CourseId}/general`} >
                                        {p.CourseName}
                                    </Link>
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>

            </div >
        }
    </div>
}


export default CourseFindByStudentClass;